export default "__VITE_ASSET__3W1reSP2__"